import { Coords, MediaElement } from 'editor/src/store/design/types';
import { PartlyOutsideWarning, WarningLevel, WarningType } from 'editor/src/store/editorModules/warnings/types';

import { isElementInsideArea } from './getOutsideSheetWarning';

// Callers check NotVisible first and skip this when it fired, so one element never
// carries both. The area is the whole spread, bleed included: only what lies past it is
// cut off, so artwork meant to run into the bleed does not warn.
function getPartlyOutsideWarning(
  element: MediaElement,
  spreadIndex: number,
  spreadCoords: Coords,
  spreadWidth: number,
  spreadHeight: number,
): PartlyOutsideWarning | undefined {
  if (element.type === 'line' || element.hidden) {
    return undefined;
  }

  const area = { left: spreadCoords.left || 0, top: spreadCoords.top || 0, width: spreadWidth, height: spreadHeight };
  if (isElementInsideArea(element, area)) {
    return undefined;
  }

  return {
    type: WarningType.PartlyOutside,
    uuid: element.uuid,
    spreadIndex,
    level: WarningLevel.Medium,
  };
}

export default getPartlyOutsideWarning;
